import script from "./statics.vue?vue&type=script&setup=true&lang=js"
export * from "./statics.vue?vue&type=script&setup=true&lang=js"

import "./statics.vue?vue&type=style&index=0&id=71803e44&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71803e44"]])

export default __exports__